




























































































































































































import Vue from 'vue';

export default Vue.extend({
  name: 'CreditCard',

  props: {
    cardType: {
      type: String,
      default: '',
    },
    fields: {
      type: Object as () => Components.CreditCard.Fields,
      default: {
        cardCvv: '',
        cardMonth: '',
        cardName: '',
        cardNumber: '',
        cardYear: '',
      },
      required: true,
    },
    labels: {
      type: Object as () => Components.CreditCard.Labels,
      default: {
        cardCvv: '',
        cardMonth: '',
        cardName: '',
        cardNumber: '',
        cardYear: '',
      },
      required: true,
    },
  },

  data() {
    return {
      focusElementStyle: null as Components.CreditCard.FocusElementStyle | null,
      currentFocus: '' as string,
      isFocused: false,
      isCardFlipped: false,
      amexCardPlaceholder: '#### ###### #####',
      dinersCardPlaceholder: '#### ###### ####',
      defaultCardPlaceholder: '#### #### #### ####',
      currentPlaceholder: '',
    };
  },

  watch: {
    currentFocus() {
      if (this.currentFocus) {
        this.changeFocus();
      } else {
        this.focusElementStyle = null;
      }
    },
    cardType() {
      this.changePlaceholder();
    },
  },

  mounted() {
    this.changePlaceholder();

    const fields = document.querySelectorAll('[data-card-field]');

    fields.forEach((element) => {
      element.addEventListener('focus', () => {
        this.isFocused = true;
        if (
          element.id === this.fields.cardYear
          || element.id === this.fields.cardMonth
        ) {
          this.currentFocus = 'cardDate';
        } else {
          this.currentFocus = element.id;
        }
        this.isCardFlipped = element.id === this.fields.cardCvv;
      });
      element.addEventListener('blur', () => {
        this.isCardFlipped = false;

        setTimeout(() => {
          if (!this.isFocused) {
            this.currentFocus = '';
          }
        }, 300);
        this.isFocused = false;
      });
    });
  },

  methods: {
    changeFocus() {
      const target = this.$refs[this.currentFocus] as HTMLElement | null;

      this.focusElementStyle = target
        ? {
          width: `${target.offsetWidth}px`,
          height: `${target.offsetHeight}px`,
          transform: `translateX(${target.offsetLeft}px) translateY(${target.offsetTop}px)`,
        }
        : null;
    },
    changePlaceholder() {
      if (this.cardType === 'amex') {
        this.currentPlaceholder = this.amexCardPlaceholder;
      } else if (this.cardType === 'dinersclub') {
        this.currentPlaceholder = this.dinersCardPlaceholder;
      } else {
        this.currentPlaceholder = this.defaultCardPlaceholder;
      }
      this.$emit('current-placeholder', this.currentPlaceholder);
      this.$nextTick(() => {
        this.changeFocus();
      });
    },
  },
});
